var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-contentt form-container"},[_c('div',{staticClass:"modal-header"}),_c('div',{staticClass:"modal-bodyy"},[_vm._t("default")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }